import { useEffect } from "react";
import { setCookieByTime } from "../utils/helpers/setCookieByTime";

export const useTrackGclid = () => {
  useEffect(() => {
    const gclid = (new URL(document.location)).searchParams.get("gclid");

    if (gclid) setCookieByTime("gclid", gclid, 90);
  }, []);
};
